@if (labels$ | async; as labels) {
<div class="marketing-label">
  @for (label of labels; track label) {
  <span [ngClass]="'marketing-label-' + label"></span>
  }
</div>
}
